export default {
  "filter": {
    "title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Prodotti del gruppo di prodotti „", _interpolate(_named("group")), "“"])},
    "type": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo"])}
    },
    "apply": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Applica filtro"])},
    "reset": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["REIMPOSTA TUTTO"])}
  },
  "results": {
    "counter": {
      "info": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["<b>", _interpolate(_named("loaded")), "</b> di <b>", _interpolate(_named("total")), "</b> prodotti visualizzati"])},
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<b>Prodotti</b> per pagina"])}
    },
    "model": {
      "attributes": {
        "id": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modello"])}
        }
      }
    },
    "pagination": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Pagina <b>", _interpolate(_named("current")), "</b> di <b>", _interpolate(_named("total")), "</b>"])}
  }
}